import { render } from "./ticketBox.vue?vue&type=template&id=6f3c58fb&scoped=true"
import script from "./ticketBox.vue?vue&type=script&lang=js"
export * from "./ticketBox.vue?vue&type=script&lang=js"

import "./ticketBox.vue?vue&type=style&index=0&id=6f3c58fb&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\버들이\\Documents\\Project\\John-I-gotta-go\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f3c58fb"]])

export default __exports__